import { observable } from 'mobx'
import * as moment from 'moment'

export default class userReadingStore {
  @observable readingData = []
  @observable sessionData = []
  @observable sessionsDataByDate = []
  @observable created = false
  @observable readingTrackDataSetId = ''
  @observable userId = ''

  updateReadingData(data) {
    this.readingData = data
  }

  updateSessionData(data) {
    this.sessionData = data
  }

  updateCreated() {
    this.created = true
  }

  updatesessionsDataByDate(date) {
    this.sessionsDataByDate = this.readingData.filter(
      d =>
        moment(new Date(d.date)).format('l') ===
        moment(new Date(date)).format('l')
    )
  }
}



// WEBPACK FOOTER //
// ./src/stores/userReadingStore.js